module.exports = __webpack_public_path__ + "img/Competition Winners-3.73d40e99.png";